/**
 * Default VAT rates by country code for restaurant items
 * These values can be overridden at the restaurant level
 * Edit on server too
 */
export const DEFAULT_VAT_RATES: Record<string, number> = {
  // Latin America
  AR: 21, // Argentina
  BO: 13, // Bolivia
  BR: 17, // Brazil (varies by state, using an average)
  CL: 19, // Chile
  CO: 19, // Colombia
  CR: 13, // Costa Rica
  EC: 12, // Ecuador
  MX: 16, // Mexico
  PA: 7, // Panama
  PE: 18, // Peru
  PY: 10, // Paraguay
  UY: 22, // Uruguay
  VE: 16, // Venezuela
  DO: 18, // Dominican Republic

  // Europe
  ES: 21, // Spain

  // North America
  US: 0, // USA (varies by state, no federal VAT)

  // Default for any other country
  DEFAULT: 0,
};

/**
 * Gets the default VAT rate for a country
 * @param countryCode ISO country code (2 letters)
 * @returns Default VAT rate percentage for the country
 */
export function getDefaultVatRate(countryCode: string): number {
  return DEFAULT_VAT_RATES[countryCode] || DEFAULT_VAT_RATES.DEFAULT;
}
